export default __webpack_public_path__ + "e014213d2c1456d5f1af91a9b0cdbc08.woff";